import { TFunction } from "react-i18next";
import i18n from "../../../i18n/i18n";
import getNamespace from "../getNamespace";

/**
 * Retrieves the translated value for a given field of an entity.
 *
 * @template T - The type of the entity document.
 * @param {string} baseKey - The base translation key for the entity.
 * @param {keyof T} field - The specific field to translate (e.g., "name" or "description").
 * @param {TFunction<string>} tCustomer - The translation function used to fetch localized values.
 * @param {T} document - The entity document containing fallback values.
 * @returns {string} The translated value if available; otherwise, the original field value from the document.
 *
 * This function checks if a translation exists for the given key.
 * If a translation is found, it returns the localized value; otherwise, it falls back to the entity's original field value.
 */
export default function getTranslatedValue<T>(
  baseKey: string,
  field: keyof T,
  tCustomer: TFunction<string>,
  document: T,
): string {
  return i18n.exists(`${baseKey}.${String(field)}`, { ns: getNamespace() })
    ? tCustomer(`${baseKey}.${String(field)}`)
    : (document[field] as unknown as string) ?? "";
}
